import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

// -------------------- Container Manager --------------------
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.webmodule-common.other.ContainerManager.';
  public static readonly containerManager_saved = `${Id.prefix}saved`;
}

export class LangContainerManager {
  private constructor() {}

  public static containerManagerSaved(dictionaryName: string): string {
    return interpolate(Id.containerManager_saved, { dictionaryName });
  }
}

export class ContainerManagerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.containerManager_saved,
      `{{dictionaryName}} Saved`,
      'Toast message for successful save in ContainerManager, with dictionary name and title.'
    );
  }
}
